import request from '@/utils/httpClient'
import { OutsourceFeeCreateParams, OutsourceFeeUpdateParams, OutsourceFeePageParams } from '@/types/domain/fee'

// 创建外包费
export function createOutsourceFee(data: OutsourceFeeCreateParams) {
  return request({
    url: 'outsourceFee',
    method: 'POST',
    data
  })
}

// 更新外包费
export function updateOutsourceFee(id: number, data: OutsourceFeeUpdateParams) {
  return request({
    url: `outsourceFee/${id}`,
    method: 'put',
    data
  })
}

// 获取列表
export function getOutsourceFeeList(id?: number) {
  return request({
    url: `business/${id}/actions/outsourceFee`,
    method: 'get'
  })
}

// 分页查询外包费 (类型化领域查询)
export function getOutsourceFeePage(params?: OutsourceFeePageParams) {
  return request({
    url: 'outsourceFee/page',
    method: 'get',
    params
  })
}

// 获取审批列表 (兼容别名)
export function getReviewList(params?: OutsourceFeePageParams) {
  return getOutsourceFeePage(params)
}

// 通过审批
export function reviewApprove(id: number, data?: object) {
  return request({
    url: `outsourceFee/${id}/actions/review/approve`,
    method: 'put',
    data
  })
}

// 通过拒绝
export function reviewReject(id: number, data?: object) {
  return request({
    url: `outsourceFee/${id}/actions/review/reject`,
    method: 'put',
    data
  })
}

// 登记发票
export function dengjiTicket(data?: object) {
  return request({
    url: 'outsourceFee/actions/ticket',
    method: 'put',
    data
  })
}

// 作废发票
export function cancelTicket(id: number) {
  return request({
    url: `outsourceFee/${id}/actions/ticket/cancel`,
    method: 'put'
  })
}

// 登记发票
export function reviewInfoById(id: number) {
  return request({
    url: `outsourceFee/${id}/actions/review`,
    method: 'get'
  })
}

// 支付确认
export function paymentConfirm(data?: object) {
  return request({
    url: 'outsourceFee/actions/paymentConfirm',
    method: 'put',
    data
  })
}

// 申请退款
export function refundApply(data?: object) {
  return request({
    url: 'outsourceFee/actions/refundApply',
    method: 'post',
    data
  })
}

// 确认退款
export function refundConfirm(data?: object) {
  return request({
    url: 'outsourceFee/actions/refundConfirm',
    method: 'put',
    data
  })
}

// 退票
export function ticketReturn(data?: object) {
  return request({
    url: 'outsourceFee/actions/ticketReturn',
    method: 'put',
    data
  })
}
